import { render } from "./RelationshipTypesList.vue?vue&type=template&id=32cd85f0"
import script from "./RelationshipTypesList.vue?vue&type=script&lang=js"
export * from "./RelationshipTypesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__